<template>
  <div class="chapters">
    <button class="chapters__btn chapters__btn--prev uppercase" :class="showPrevButton ? '' : 'chapters__btn--hidden'" @click="showPrev()" >
      Zurück
    </button>
    <ul class="chapters__list" data-test="tab-chapters" :style="getOffset()" :test="offset">
      <entry v-for="(chapter, index) in chapters" :chapter="chapter" :index="index" :key="index">
      </entry>
    </ul>
    <button class="chapters__btn chapters__btn--next uppercase" :class="showNextButton ? '' : 'chapters__btn--hidden'" @click="showNext()">
      Weitere
    </button>
  </div>
</template>

<script>
import { mapState } from 'redux-vuex';
import { toggleTab } from '@/store/actions/tabs';
import store from '@/store';
import select from '@/store/selectors';
import Entry from './components/Entry';
import { showPrevChapters, showNextChapters } from '@/store/actions/chapters';

export default {
  components: {
    Entry,
  },
  data: mapState({
    chapters: select.chapters.list,
    showPrevButton: select.chapters.showPrevButton,
    showNextButton: select.chapters.showNextButton,
    offset: select.chapters.offset,
  }),
  methods: {
    getOffset() {
      return this.offset > 0 ? `top: ${this.offset * -30}px;` : 'top: 0px;';
    },
    closeTab() {
      store.dispatch(toggleTab('chapters'));
    },
    showPrev() {
      store.dispatch(showPrevChapters());
    },
    showNext() {
      store.dispatch(showNextChapters());
    },
  },
};
</script>

<style scoped lang="scss">
  @import '~@/assets/scss/tokens/tab.scss';
  @import '~@/assets/scss/media.scss';

  .chapters {
    @extend %tab-wrapper;
  }

  .chapters__list {
    position: absolute;
    top: 0;
    transition: top .3s ease-in-out;
  }

  .chapters__btn {
    background: #333;
    color: #999;
    height: 30px;
    font-size: 12px;
    left: 0;
    line-height: 30px;
    position: absolute;
    text-align: left;
    width: 100%;
    z-index: 1;

    &--prev {
      top: 0;
      transition: top .3s ease-in-out;

      &.chapters__btn--hidden {
        top: -30px;
      }
    }

    &--next {
      bottom: 0;
      transition: bottom .3s ease-in-out;

      &.chapters__btn--hidden {
        bottom: -30px;
      }
    }

    &:hover {
      color: #fff;
    }
  }
</style>
